var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({directives:[{name:"mask",rawName:"v-mask",value:(_vm.phoneFieldMask),expression:"phoneFieldMask"}],ref:"phoneInput",attrs:{"label":_vm.label,"rules":_vm.rules,"masked":"true","clearable":"","outlined":""},on:{"click:clear":_vm.clearPhone,"change":_vm.setPhone}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }